// filepath: apps/web/src/features/tasks/TaskInboxPage.tsx
//
// Page component for the human-task inbox (FR-UI-TASK-1).
//
// Renders:
//   - Page title ("Task Inbox")
//   - The TaskInbox component (tabs + task list)

import React from "react";
import { TaskInbox } from "./TaskInbox";

/**
 * TaskInboxPage — the full page for the task inbox.
 *
 * Thin wrapper around TaskInbox. Adds page chrome (title, layout).
 * In v1, the page has no additional filters or pagination beyond
 * what the inbox API supports.
 */
export function TaskInboxPage(): React.ReactElement {
  return (
    <main
      data-testid="task-inbox-page"
      aria-labelledby="task-inbox-title"
      style={{
        padding: "24px",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      <header style={{ marginBottom: "24px" }}>
        <h1
          id="task-inbox-title"
          data-testid="task-inbox-title"
          style={{
            fontSize: "20px",
            fontWeight: 700,
            color: "#111827",
            margin: 0,
          }}
        >
          Task Inbox
        </h1>
        <p
          style={{
            fontSize: "14px",
            color: "#6b7280",
            margin: "4px 0 0 0",
          }}
        >
          Complete tasks assigned to you or unclaimed tasks visible to your
          roles.
        </p>
      </header>

      <TaskInbox />
    </main>
  );
}
